import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Heading } from '@puppet/react-components';
import useWorkspaceName from '@hooks/useWorkspaceName';
import { LINKS } from 'src/routes';

type PeHeadingProps = {
  root?: boolean;
};

const PeHeading: React.FC<PeHeadingProps> = ({ root = false }) => {
  const { t } = useTranslation('codeDelivery');
  const workspace = useWorkspaceName();

  const href = root
    ? 'new'
    : LINKS.settings.newPuppetEnterprise({ path: { workspace } });

  return (
    <div className="pe-list-header__cta">
      <Heading as="h3">{t('peList.page.title')}</Heading>
      <Button as={NavLink} to={href}>
        {t('peList.buttons.addPe.label')}
      </Button>
    </div>
  );
};

export default PeHeading;
